// /src/pages/publicTab/AllianceTab.jsx

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import useImageModal from '../../hooks/useImageModal';
import ImageModal from '../../components/ImageModal';
import Allies from './Allies';

function AllianceTab() {
  const documentName = 'Alliances';
  const STYLE_ID = `style-${documentName}`;

  const { modalIsOpen, selectedImageSrc, openModal, closeModal } = useImageModal();
  const publicContainerRef = useRef(null);
  const [publicContent, setPublicContent] = useState('');
  const [hash, setHash] = useState(null);

  // fetch Lexical public HTML + CSS and inject into DOM securely
  const fetchRteContents = async () => {
    try {
      const resp = await axios.get('/api/admin/lexical/retrieve-public-html-document', {
        params: { documentName },
      });
      const { htmlContent, cssPublic, contentHash } = resp.data.data;

      let styleEl = document.getElementById(STYLE_ID);
      const prevHash = styleEl?.getAttribute('data-hash') || null;

      if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = STYLE_ID;

        // apply CSP nonce before injecting
        const meta = document.querySelector('meta[name="csp-nonce"]');
        const nonce = meta && meta.content;
        if (nonce) styleEl.setAttribute('nonce', nonce);

        document.head.appendChild(styleEl);
      }

      if (contentHash && contentHash !== prevHash) {
        styleEl.textContent = cssPublic || '';
        styleEl.setAttribute('data-hash', contentHash);
        setHash(contentHash);
      }

      setPublicContent(htmlContent || '');
    } catch (error) {
      console.error('Error fetching public HTML+CSS for Alliances:', error);
      setPublicContent('');
    }
  };

  useEffect(() => {
    fetchRteContents();
  }, []);

  // handle image clicks for modal display
  useEffect(() => {
    const handleImageClick = (event) => {
      if (
        event.target.className.includes('e-rte-image') &&
        !event.target.className.includes('rte-emoji')
      ) {
        openModal(event.target.src);
      }
    };

    const container = publicContainerRef.current;
    if (container) {
      container.addEventListener('click', handleImageClick);
      return () => container.removeEventListener('click', handleImageClick);
    }
  }, [openModal]);

  // Trusted Types passthrough for CSP strict mode
  const trustedHTML = (() => {
    if (window.trustedTypes) {
      try {
        const policy = window.trustedTypes.createPolicy('pallasPages', {
          createHTML: (input) => input,
          createScript: (input) => input,
          createScriptURL: (input) => input,
        });
        return policy.createHTML(publicContent);
      } catch {
        return window.trustedTypes.createPolicy('pallasPages').createHTML(publicContent);
      }
    }
    return publicContent;
  })();

  return (
    <div className="alliances-tab-wrapper">
      <div className="public-container margin-bottom-spacer">
        <div
          ref={publicContainerRef}
          className="public-rte-content-container lexical-rendered-content"
          data-doc={documentName}
          role="document"
          dangerouslySetInnerHTML={{ __html: trustedHTML }}
        />
      </div>

      <Allies />
      <div className="margin-bottom-spacer" />

      <ImageModal
        isOpen={modalIsOpen}
        onClose={closeModal}
        src={selectedImageSrc}
        className="e-rte-image-custom-modal-content"
      />
    </div>
  );
}

export default AllianceTab;
